/**
 * @generated SignedSource<<6ad461128426e804eec52c6f63986998>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddSubIssueButtonGroup$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"SubIssuesCreateDialog">;
  readonly " $fragmentType": "AddSubIssueButtonGroup";
};
export type AddSubIssueButtonGroup$key = {
  readonly " $data"?: AddSubIssueButtonGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddSubIssueButtonGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddSubIssueButtonGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubIssuesCreateDialog"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "1820d11cc44d0aa77ba081f1eea23ad7";

export default node;
